import type { CodeConfirmationPrompt } from 'app/types/plan';

export function codeConfirmationKey(userId: string, prompt: Pick<CodeConfirmationPrompt, 'code' | 'version'>) {
  return JSON.stringify([userId, prompt.code, prompt.version]);
}

export function selectSubscriptionCodeConfirmation(
  prompts: CodeConfirmationPrompt[] | undefined,
  shown: string[] | null | undefined,
  userId: string | undefined,
  planCode: string | undefined,
) {
  if (
    !userId ||
    prompts === undefined ||
    shown === undefined ||
    (planCode !== 'FREETRIAL' && planCode !== 'CREDITMEMBER')
  )
    return undefined;
  const shownKeys = new Set(shown);
  const candidates = prompts
    .filter((prompt) => prompt.enabled && !shownKeys.has(codeConfirmationKey(userId, prompt)))
    .map((prompt) => ({ code: prompt.code, prompt }));
  // The API applies address eligibility. Stable code order only resolves overlapping regions;
  // no offer has a special priority.
  return candidates.sort((a, b) => a.code.localeCompare(b.code))[0];
}

export function codeConfirmationText(prompt: CodeConfirmationPrompt, language: string, name = '') {
  const locale = language.toLowerCase();
  const baseLanguage = locale.split('-')[0] ?? 'en';
  const text = prompt.translations[locale] ?? prompt.translations[baseLanguage] ?? prompt.translations.en;
  const personalize = (value: string) => value.replaceAll('{{name}}', name);
  return {
    ...text,
    title: personalize(text.title),
    yesLabel: personalize(text.yesLabel),
    noLabel: personalize(text.noLabel),
    ...(text.eyebrow !== undefined && { eyebrow: personalize(text.eyebrow) }),
    ...(text.description !== undefined && { description: personalize(text.description) }),
  };
}
